export enum NotificationType {
  Success = 'success',
  Error = 'error',
  Alert = 'alert',
  Info = 'info',
  Warn = 'warn',
  Bootstrap = 'bootstrap',
}
